module.exports = __webpack_public_path__ + "static/media/Murmuratto_With-Icon_Purple.d5cbad3b.png";